import type { ExpectedReturnItem, ExpectedReturnsQuery, Page, ReceiveResult, ReceiveTruckInput, YardReceiptView } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export type { ExpectedReturnItem, ReceiveResult, YardReceiptView };

export function listExpectedReturns(query: ExpectedReturnsQuery): Promise<Page<ExpectedReturnItem>> {
  return api<Page<ExpectedReturnItem>>(`/yard/expected-returns?${toListParams(query)}`);
}

export function getYardReceipt(tripId: string): Promise<YardReceiptView> {
  return api<YardReceiptView>(`/yard/trips/${tripId}/receipt`);
}

export function receiveTruck(tripId: string, input: ReceiveTruckInput): Promise<ReceiveResult> {
  return api<ReceiveResult>(`/yard/trips/${tripId}/receive`, { method: 'POST', body: JSON.stringify(input) });
}
